import { render, staticRenderFns } from "./v-alynk-simple-table.vue?vue&type=template&id=25127ac0&scoped=true&"
import script from "./v-alynk-simple-table.vue?vue&type=script&lang=ts&"
export * from "./v-alynk-simple-table.vue?vue&type=script&lang=ts&"
import style0 from "./v-alynk-simple-table.vue?vue&type=style&index=0&id=25127ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25127ac0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
